import StatusBadge from '../StatusBadge';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Printer } from 'lucide-react';

export function POPrintOptionsDialog({ handlePrint, printPO, printTandaTerima, setShowPrintOptions, showPrintOptions, user }) {
  return (
    <Dialog open={showPrintOptions} onOpenChange={setShowPrintOptions}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Printer className="h-5 w-5 text-blue-600" />
            Pilih Dokumen untuk Dicetak
          </DialogTitle>
        </DialogHeader>

        {printPO && (
          <div className="space-y-4">
            <div className="bg-slate-50 p-3 rounded-lg">
              <p className="text-sm"><strong>No. PO:</strong> {printPO.po_number}</p>
              <p className="text-sm"><strong>Status:</strong> <StatusBadge status={printPO.status} /></p>
            </div>

            <div className="space-y-2">
              <Button 
                className="w-full justify-start bg-blue-600 hover:bg-blue-700" 
                onClick={() => { handlePrint(printPO); setShowPrintOptions(false); }}
              >
                <Printer className="h-4 w-4 mr-2" />
                Cetak Purchase Order (PO)
              </Button>

              {['diterima', 'diterima_adj', 'diterima_partial'].includes(printPO.status)
                && ['staff_gudang', 'admin'].includes(user?.role) && (
                <Button 
                  className="w-full justify-start bg-green-600 hover:bg-green-700" 
                  onClick={() => { printTandaTerima(printPO); setShowPrintOptions(false); }}
                >
                  <Printer className="h-4 w-4 mr-2" />
                  Cetak Tanda Terima Barang (TTB)
                </Button>
              )}
            </div>

            <Button variant="outline" className="w-full" onClick={() => setShowPrintOptions(false)}>
              Batal
            </Button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
